import { inject, InjectionToken, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

export const WindowToken = new InjectionToken<Window | undefined>('Window object token', {
  providedIn: 'root',
  factory(): Window | undefined {
    const platformId = inject(PLATFORM_ID)
    if (isPlatformBrowser(platformId)) {
      return window as Window
    }
    return undefined
  },
})
